import apiServices from "../apiServices";

export const usersApi = {
  getUserById: async (id) => {
    const response = await apiServices.get(`api/v1/users/${id}`);
    return response.data;
  },
  updateUser: async (id, data) => {
    const response = await apiServices.patch(`api/v1/users/${id}`, data);
    return response.data;
  },
  updatePassword: async (id, data) => {
    const response = await apiServices.patch(
      `api/v1/users/${id}/password`,
      data
    );
    return response.data;
  },
  getUsersbyFilters: async (params = {}) => {
    const {
      page = 1,
      limit = 10,
      search = "",
      role = "",
      isActive = "",
      minCpdPoints = "",
      maxCpdPoints = "",
      email = "",
      name = "",
      sortBy = "createdAt",
      sortOrder = "desc",
    } = params;
    const queryParams = new URLSearchParams();
    queryParams.append("page", page.toString());
    queryParams.append("limit", limit.toString());
    if (search) queryParams.append("search", search);
    if (role) queryParams.append("role", role);
    if (isActive) queryParams.append("isActive", isActive);
    if (minCpdPoints) queryParams.append("minCpdPoints", minCpdPoints);
    if (maxCpdPoints) queryParams.append("maxCpdPoints", maxCpdPoints);
    if (email) queryParams.append("email", email);
    if (name) queryParams.append("name", name);
    if (sortBy) queryParams.append("sortBy", sortBy);
    if (sortOrder) queryParams.append("sortOrder", sortOrder);
    const response = await apiServices.get(
      `api/v1/users/admin?${queryParams.toString()}`
    );
    return response.data;
  },
  getUserByIdAdmin: async (id) => {
    const response = await apiServices.get(`api/v1/users/admin/${id}`);
    return response.data;
  },
  deleteUser: async (id) => {
    const response = await apiServices.delete(`api/v1/users/${id}`);
    return response.data;
  },
};
